import React from 'react';
import CampaignForm from './CampaignForm';

const DetailsTab = ({ 
    campaignData, 
    setCampaignData, 
    schema, 
    uiSchema, 
    onSave, 
    onPublish, 
    wsProvider 
}) => {
    if (!campaignData) {
        return (
            <div className="text-center p-4">
                <p>Please select a campaign to view details</p>
            </div>
        );
    }

    return (
        <CampaignForm
            campaign={campaignData}
            setCampaign={setCampaignData}
            schema={schema}
            uiSchema={uiSchema}
            onSave={onSave}
            onPublish={onPublish}
            wsProvider={wsProvider}
        />
    );
};

export default DetailsTab; 